module.exports = __webpack_public_path__ + "img/reminders-2.4fc29741.gif";